/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TierCode } from './TierCode';
import {
    TierCodeFromJSON,
    TierCodeFromJSONTyped,
    TierCodeToJSON,
    TierCodeToJSONTyped,
} from './TierCode';

/**
 * 
 * @export
 * @interface CreateBillingCheckoutSessionRequest
 */
export interface CreateBillingCheckoutSessionRequest {
    /**
     * 
     * @type {TierCode}
     * @memberof CreateBillingCheckoutSessionRequest
     */
    tierCode: TierCode;
    /**
     * 
     * @type {string}
     * @memberof CreateBillingCheckoutSessionRequest
     */
    billingPeriod: CreateBillingCheckoutSessionRequestBillingPeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateBillingCheckoutSessionRequest
     */
    successUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBillingCheckoutSessionRequest
     */
    cancelUrl: string;
}


/**
 * @export
 */
export const CreateBillingCheckoutSessionRequestBillingPeriodEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type CreateBillingCheckoutSessionRequestBillingPeriodEnum = typeof CreateBillingCheckoutSessionRequestBillingPeriodEnum[keyof typeof CreateBillingCheckoutSessionRequestBillingPeriodEnum];


/**
 * Check if a given object implements the CreateBillingCheckoutSessionRequest interface.
 */
export function instanceOfCreateBillingCheckoutSessionRequest(value: object): value is CreateBillingCheckoutSessionRequest {
    if (!('tierCode' in value) || value['tierCode'] === undefined) return false;
    if (!('billingPeriod' in value) || value['billingPeriod'] === undefined) return false;
    if (!('successUrl' in value) || value['successUrl'] === undefined) return false;
    if (!('cancelUrl' in value) || value['cancelUrl'] === undefined) return false;
    return true;
}

export function CreateBillingCheckoutSessionRequestFromJSON(json: any): CreateBillingCheckoutSessionRequest {
    return CreateBillingCheckoutSessionRequestFromJSONTyped(json, false);
}

export function CreateBillingCheckoutSessionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBillingCheckoutSessionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tierCode': TierCodeFromJSON(json['tierCode']),
        'billingPeriod': json['billingPeriod'],
        'successUrl': json['successUrl'],
        'cancelUrl': json['cancelUrl'],
    };
}

export function CreateBillingCheckoutSessionRequestToJSON(json: any): CreateBillingCheckoutSessionRequest {
    return CreateBillingCheckoutSessionRequestToJSONTyped(json, false);
}

export function CreateBillingCheckoutSessionRequestToJSONTyped(value?: CreateBillingCheckoutSessionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tierCode': TierCodeToJSON(value['tierCode']),
        'billingPeriod': value['billingPeriod'],
        'successUrl': value['successUrl'],
        'cancelUrl': value['cancelUrl'],
    };
}

